// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled, Theme } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }: { theme?: Theme | any; ownerState: any }) => {
  const { boxShadows, transitions, breakpoints, functions } = theme;
  const { miniSideform } = ownerState;

  const { xxl } = boxShadows;
  const { pxToRem } = functions;

  let backgroundValue = "#fafafa";

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    background: backgroundValue,
    width: window.innerWidth < breakpoints.values.lg ? "95%" : pxToRem(375),
    right: 0,
    transform: `translate3d(0, 0, 0)`,
    transition: transitions.create(["transform", "width"], {
      easing: transitions.easing.easeOut,
      duration: transitions.duration.enteringScreen,
    }),
    willChange: "transform",
  });

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    background: backgroundValue,
    width: 0,
    right: 0,
    transform: `translate3d(${
      window.innerWidth < breakpoints.values.lg ? "95%" : pxToRem(400)
    }, 0, 0)`,
    transition: transitions.create(["transform", "width"], {
      easing: transitions.easing.sharp,
      duration: transitions.duration.leavingScreen,
    }),
    willChange: "transform",
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: xxl,
      border: "none",

      ...(miniSideform ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
